import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import { CustomerState } from '@/customer/vuex/store';
import { AccountState } from '@/common/models/Account';
import { CustomerFilter } from '@/customer/models/CustomerFilter';
import { CustomerList } from '@/customer/models/CustomerList';
import { CustomerImport } from '@/customer/models/CustomerImport';
import { CustomerRemarkRule } from '@/customer/models/CustomerRemarkRule';
import Filters from './filters';

export default {
  computed: mapState({
    filterNothing(state: AppState): boolean {
      const filter = state.customerState.customerFilter;
      return !Filters.isFilterSex(filter) &&
        !Filters.isFilterSubscribe(filter) &&
        !Filters.isFilterArea(filter) &&
        !Filters.isFilterSubscribeScene(filter) &&
        !Filters.isFilterInteract(filter) &&
        !Filters.isFilterTrace(filter) &&
        !Filters.isFilterScore(filter) &&
        !Filters.isFilterScoreSum(filter) &&
        !Filters.isFilterMember(filter) &&
        !Filters.isFilterGroup(filter) &&
        !Filters.isFilterRemark(filter) &&
        !Filters.isFilterCustom(filter) &&
        !Filters.isFilterTopic(filter);
    },
    customerState(state: AppState): CustomerState {
      return state.customerState;
    },
    props(state: AppState): Array<any> {
      return state.customerState.props;
    },
    accountState(state: AppState): AccountState {
      return state.accountState;
    },
    customerFilter(state: AppState): CustomerFilter {
      return state.customerState.customerFilter;
    },
    customerList(state: AppState): CustomerList {
      return state.customerState.customerList;
    },
    customerImport(state: AppState): CustomerImport {
      return state.customerState.customerImport;
    },
    customerRemarkRule(state: AppState): CustomerRemarkRule {
      return state.customerState.customerRemarkRule;
    },
    duringFirstSync(state: AppState): boolean {
      return state.customerState.duringFirstSync;
    },
    syncPercent(state: AppState): number {
      return state.customerState.syncPercent;
    },
    showTaskEntry(state: AppState): boolean {
      return state.customerState.showTaskEntry;
    },
    showChat(state: AppState): boolean {
      return state.customerState.showChat;
    },
    chatOpenid(state: AppState): string | undefined {
      return state.customerState.chatOpenid;
    },
    isFilterSex(state: AppState): boolean {
      return Filters.isFilterSex(state.customerState.customerFilter);
    },
    isFilterSubscribe(state: AppState): boolean {
      return Filters.isFilterSubscribe(state.customerState.customerFilter);
    },
    isFilterArea(state: AppState): boolean {
      return Filters.isFilterArea(state.customerState.customerFilter);
    },
    isFilterSubscribeScene(state: AppState): boolean {
      return Filters.isFilterSubscribeScene(state.customerState.customerFilter);
    },
    isFilterInteract(state: AppState): boolean {
      return Filters.isFilterInteract(state.customerState.customerFilter);
    },
    isFilterTrace(state: AppState): boolean {
      return Filters.isFilterTrace(state.customerState.customerFilter);
    },
    isFilterScore(state: AppState): boolean {
      return Filters.isFilterScore(state.customerState.customerFilter);
    },
    isFilterScoreSum(state: AppState): boolean {
      return Filters.isFilterScoreSum(state.customerState.customerFilter);
    },
    isFilterMember(state: AppState): boolean {
      return Filters.isFilterMember(state.customerState.customerFilter);
    },
    isFilterGroup(state: AppState): boolean {
      return Filters.isFilterGroup(state.customerState.customerFilter);
    },
    isFilterRemark(state: AppState): boolean {
      return Filters.isFilterRemark(state.customerState.customerFilter);
    },
    isFilterCustom(state: AppState): boolean {
      return Filters.isFilterCustom(state.customerState.customerFilter);
    },
    isFilterTopic(state: AppState): boolean {
      return Filters.isFilterTopics(state.customerState.customerFilter);
    },
  }),
};
